import React from 'react';
import SubLayout from '../../components/Layout/SubLayout'
import strings from "../../components/Language";
import "./profile.scss"

import ArrowForword from './../../assets/images/icons/arrow_forword.svg';
import checkGreen from './../../assets/images/icons/radio-button-green.png';
import checkWhite from './../../assets/images/icons/radio-button-wwhite.png';

import Modal from '@mui/material/Modal';

import packageJson from '../../../package.json';
class SystemSettingScreen extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isModal: false,
			lan_: localStorage.getItem("language"),
		}
	}

	Logout() {
		localStorage.clear();
		window.location.reload(false);
	}

	changeLanguage() {
		var self = this;
		if (self.state.lan_) {
			strings.setLanguage(self.state.lan_);
			localStorage.setItem("language", self.state.lan_);
			self.setState({ isModal: false, });
		}
	}

	closeModal() {
		this.setState({
			isModal: false,
		});
	}

	render() {
		return (
			<SubLayout data={{ "title": strings.system_setting }}>
				<div className="profile-subpage">
					<div className='profile-panel'>
						<div onClick={() => this.setState({ isModal: true })} className='profile-list-item' style={{ cursor: 'pointer' }}>
							<div className='profile-list-left'>
								<span>{strings.language}</span>
							</div>
							<div className='profile-list-right'>
								<span>
									{(this.state.lan_ == 'en') ? strings.english : ''}
									{(this.state.lan_ == 'zh') ? strings.chinese : ''}
								</span>
								<img src={ArrowForword} alt="ArrowForword"></img>
							</div>
						</div>
						<div className='profile-list-item'>
							<div className='profile-list-left'>
								<span>{strings.firmware_version}</span>
							</div>
							<div className='profile-list-right'>
								<span>V {packageJson.version}</span>
							</div>
						</div>
					</div>

					<div className='profile-form-card' style={{ marginTop: 14 }}>
						<button type="button" onClick={() => this.Logout()} className='profile-logout-btn'>
							{strings.logout}
						</button>
					</div>
				</div>

				<Modal
					open={this.state.isModal ?? false}
					className="itemModal"
					onClose={() => this.closeModal()}
					style={{ overflow: 'scroll' }}
				>
					<>
						<div className="modal-dialog modal-dialog-centered modal-sm">
							<div className="modal-content">
								<div className="modal-header" style={{ width: "100%" }}>
									<span style={{ color: "#FFF" }}>{strings.language}</span>
									<button onClick={() => this.closeModal()}
										type="button" className="close" data-dismiss="modal" aria-label="Close"
										style={{ background: "transparent", borderWidth: 0 }}
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div className="modal-body">
									<div className='lang-options'>
										<div onClick={() => this.setState({ lan_: "en" })} className={'lang-option' + (this.state.lan_ == 'en' ? ' selected' : '')}>
											<img src={(this.state.lan_ == 'en') ? checkGreen : checkWhite} alt="en" width="20" />
											<span>{strings.english}</span>
										</div>
										<div onClick={() => this.setState({ lan_: "zh" })} className={'lang-option' + (this.state.lan_ == 'zh' ? ' selected' : '')}>
											<img src={(this.state.lan_ == 'zh') ? checkGreen : checkWhite} alt="zh" width="20" />
											<span>{strings.chinese}</span>
										</div>
									</div>
									<div style={{ marginTop: 16 }}>
										<button type="button" onClick={() => this.changeLanguage()} className='profile-save-btn'>
											{strings.save}
										</button>
									</div>
								</div>
							</div>
						</div>
					</>
				</Modal>
			</SubLayout >
		);
	}
}

export default SystemSettingScreen;
